// extracted by mini-css-extract-plugin
export var container = "HowToParticipate-module--container--be3dc";
export var contentHeader = "HowToParticipate-module--contentHeader--79cb7";
export var heading = "HowToParticipate-module--heading--13c74";
export var howToParticipate = "HowToParticipate-module--howToParticipate--36925";
export var howToParticipateHeading = "HowToParticipate-module--howToParticipateHeading--f3a49 HowToParticipate-module--heading--13c74";
export var imageStep = "HowToParticipate-module--imageStep--6baff";
export var step = "HowToParticipate-module--step--3d033";
export var stepButton = "HowToParticipate-module--stepButton--8bd02";
export var stepContent = "HowToParticipate-module--stepContent--78f36";
export var stepHeader = "HowToParticipate-module--stepHeader--0d52d HowToParticipate-module--heading--13c74";
export var steps = "HowToParticipate-module--steps--83aec";